import React, { useState } from "react";
import "./Header.scss";
import { scroller } from "react-scroll";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PaylaterLogo from "@assets/img/paylater-logo.svg";
import BuisnessIcon from "@assets/img/buisnessIcon.svg";
import ClientIcon from "@assets/img/client-icon.svg";
import UzFlag from "@assets/img/uzFlag.png";
import RussianFlag from "@assets/img/russianFlag.png";
import logInIcon from "@assets/img/logInIcon.svg";
import burgerMenu from "@assets/img/burgerMenu.svg";
import burgerMenuExit from "@assets/img/burgerexit.svg";
import { useGlobalState } from "@/context/GlobalStateContext";
import { backOfficeUrl } from "@services/api";

function Header() {
  const [menuState, setMenuState] = useState(false);
  const { language, setLanguage, siteVersion, setSiteVersion } =
    useGlobalState();
  const { t: tSiteVersion } = useTranslation([`${siteVersion}`]);
  const { t: tCommon } = useTranslation(["common"]);
  const navigate = useNavigate();
  const location = useLocation();
  const mobileAppUrl = "https://paylateruz.onelink.me/iEhj/bwux0lsc";

  const scrollToAnchor = (anchorId) => {
    if (location.pathname !== "/") {
      navigate(`/#${anchorId}`);
    } else {
      scroller.scrollTo(anchorId, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -70,
      });
    }
  };

  const menuController = (actionType) => {
    if (actionType === "open") setMenuState(true);
    else setMenuState(false);
  };
  const loginUrl = siteVersion === "client" ? mobileAppUrl : backOfficeUrl;

  return (
    <div className="header-container">
      <div className="header-buttons mob-vers">
        {language === "ru" ? (
          <button className="mob-btn" onClick={() => setLanguage("uz")}>
            <img
              src={UzFlag}
              alt="uz-flag"
              className="desc-btn__lang"
              draggable="false"
            />{" "}
            UZ
          </button>
        ) : (
          <button className="mob-btn" onClick={() => setLanguage("ru")}>
            <img
              src={RussianFlag}
              alt="ru-flag"
              className="desc-btn__lang"
              draggable="false"
            />{" "}
            RU
          </button>
        )}
      </div>

      <Link to="/" aria-label="Paylater" className="header-mobile-logo-link">
        <img className="mob-icon" src={PaylaterLogo} alt="paylater-logo" />
      </Link>

      <div className="header-separating-container">
        <Link to="/" aria-label="Paylater">
          <img src={PaylaterLogo} alt="paylater-logo" />
        </Link>
        <div className="header-anchors-container">
          <div
            className="header-anchor"
            onClick={() => scrollToAnchor("benefits")}
          >
            {tCommon("anchors.benefits")}
          </div>

          {/* <div
            className="header-anchor"
            onClick={() => scrollToAnchor("partners")}
          >
            {tCommon("anchors.partnerShops")}
          </div> */}
          {/*<a*/}
          {/*  className="header-anchor"*/}
          {/*  href={`${apiUrl}/client/PartnersOrder/10`}*/}
          {/*  target="_blank"*/}
          {/*  rel="noreferrer"*/}
          {/*  onClick={handleClick}*/}
          {/*>*/}
          {/*  {tSiteVersion("promoBlock.limit-btn.btn")}*/}
          {/*</a>*/}
          <div
            className="header-anchor"
            onClick={() => scrollToAnchor("banner")}
          >
            {tCommon("anchors.banner")}
          </div>
          <div
            className="header-anchor"
            onClick={() => scrollToAnchor("howItWork")}
          >
            FAQ
          </div>
          <a className="header-anchor" href="/instructions" rel="noreferrer">
            {tCommon("anchors.notify")}
          </a>
        </div>
      </div>

      <div className="header-buttons">
        {siteVersion === "client" ? (
          <button
            className="desc-btn"
            onClick={() => setSiteVersion("business")}
          >
            {" "}
            <img src={BuisnessIcon} alt="buisness-icon" />{" "}
            {tSiteVersion("button.text")}{" "}
          </button>
        ) : (
          <button className="desc-btn" onClick={() => setSiteVersion("client")}>
            {" "}
            <img src={ClientIcon} alt="client-icon" />{" "}
            {tSiteVersion("button.text")}{" "}
          </button>
        )}

        {language === "ru" ? (
          <button className="desc-btn" onClick={() => setLanguage("uz")}>
            <img
              src={UzFlag}
              alt="uz-flag"
              className="desc-btn__lang"
              draggable="false"
            />{" "}
            UZ
          </button>
        ) : (
          <button className="desc-btn" onClick={() => setLanguage("ru")}>
            <img
              src={RussianFlag}
              alt="ru-flag"
              className="desc-btn__lang"
              draggable="false"
            />{" "}
            RU
          </button>
        )}

        <a
          href={loginUrl}
          target="_blank"
          rel="noreferrer"
          id="enter-lk"
        >
          <button className="header-login-button desc-btn">
            <img src={logInIcon} alt="login-icon" />
          </button>
        </a>

        <button
          className={`burger-btn ${menuState ? "active" : ""}`}
          onClick={() => menuController("open")}
        >
          {" "}
          <img src={burgerMenu} alt="burgerMenu" />{" "}
        </button>
        <button
          className={`burger-exit-btn ${menuState ? "" : "active"}`}
          onClick={() => menuController()}
        >
          {" "}
          <img src={burgerMenuExit} alt="burgerMenuExit" />{" "}
        </button>
      </div>

      <div className={`mobile-menu ${menuState ? "open" : ""}`}>
        <div className="header-buttons">
          {siteVersion === "client" ? (
            <button
              className="mob-btn"
              onClick={() => {
                setSiteVersion("business");
                menuController();
              }}
            >
              <img src={BuisnessIcon} alt="buisness-icon" />{" "}
              {tSiteVersion("button.text")}
            </button>
          ) : (
            <button
              className="mob-btn"
              onClick={() => {
                setSiteVersion("client");
                menuController();
              }}
            >
              <img src={ClientIcon} alt="client-icon" />{" "}
              {tSiteVersion("button.text")}
            </button>
          )}
        </div>

        <div className="menu-links">
          <div
            className="menu-link"
            onClick={() => {
              scrollToAnchor("benefits");
              menuController();
            }}
          >
            {tCommon("anchors.benefits")}
          </div>
          {/* <div
            className="menu-link"
            onClick={() => {
              scrollToAnchor("partners");
              menuController();
            }}
          >
            {tCommon("anchors.partnerShops")}
          </div> */}
          {/*<a*/}
          {/*  className="menu-link"*/}
          {/*  href={`${apiUrl}/client/PartnersOrder/10`}*/}
          {/*  target="_blank"*/}
          {/*  rel="noreferrer"*/}
          {/*  onClick={() => {*/}
          {/*    menuController();*/}
          {/*    handleClick();*/}
          {/*  }}*/}
          {/*>*/}
          {/*  {tSiteVersion("promoBlock.limit-btn.btn")}*/}
          {/*</a>*/}
          <div
            className="menu-link"
            onClick={() => {
              scrollToAnchor("banner");
              menuController();
            }}
          >
            {tCommon("anchors.banner")}
          </div>
          <div
            className="menu-link"
            onClick={() => {
              scrollToAnchor("howItWork");
              menuController();
            }}
          >
            FAQ
          </div>
          <a
            className="menu-link"
            href="/instructions"
            rel="noreferrer"
            onClick={() => {
              menuController();
            }}
          >
            {tCommon("anchors.notify")}
          </a>
        </div>
        <div className="header-buttons login-btn">
          <a
            href={loginUrl}
            target="_blank"
            rel="noreferrer"
            id="enter-lk"
          >
            <button className="mob-btn">
              <img src={logInIcon} alt="loginIcon-icon" /> {tCommon("login")}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Header;
